import { EmbeddedBrightcovePlayer } from './brightcove-player';

document.addEventListener('DOMContentLoaded', () => {
    const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;

    new EmbeddedBrightcovePlayer().initialize(
        document.getElementById(context.playerTagId),
        context.brightcoveId,
        context.accountId,
        context.playerId,
    );
});
